import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";

type DialogProps = {
  visible: boolean;
  setVisible: (state: boolean) => void;
  confirmMessage?: string;

  confirmedCallback: () => void;
};

const ConfirmDialog = ({
  visible,
  setVisible,
  confirmMessage = T("action.confirm"),
  confirmedCallback,
}: DialogProps) => {
  const [message, setMessage] = useState("");
  const footer = () => {
    return (
      <div>
        <Button
          onClick={() => setVisible(false)}
          label={T("word.cancel")}
          icon="pi pi-times"
          className="p-button-danger"
        />
        <Button
          onClick={() => {
            confirmedCallback();
            setVisible(false);
          }}
          label={T("action.confirm")}
          disabled={message !== confirmMessage}
          icon="pi pi-confirm"
          className="p-button-success"
        />
      </div>
    );
  };

  return (
    <Dialog
      onHide={() => setVisible(false)}
      visible={visible}
      header={T("action.confirm-action")}
      footer={footer}
    >
      <div className="flex flex-column gap-1">
        <div>
          {T("confirm-dialog.if-you-want-to-confirm-your-action-write")}[ <b>{confirmMessage}</b> ]
        </div>
        <InputText onChange={event => setMessage(event.target.value)} value={message} />
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
